/* REMOVE ANSWER */
export const REMOVE_QUIZZ_ANSWER = "REMOVE_QUIZZ_ANSWER"
export const REMOVE_QUIZZ_ANSWER_SUCCESS = "REMOVE_QUIZZ_ANSWER_SUCCESS"
export const REMOVE_QUIZZ_ANSWER_CLEAN = "REMOVE_QUIZZ_ANSWER_CLEAN"
export const REMOVE_QUIZZ_ANSWER_ERROR = "REMOVE_QUIZZ_ANSWER_ERROR"
